import(/* webpackMode: "eager", webpackExports: ["default"] */ "/lexoya/src/views/DocsRedirect.tsx");
